import { bool, number } from "prop-types";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { useStores } from "@hooks";
import { Tag } from "@components";
import Grid from "@material-ui/core/Grid";

export const SeatsCounter = observer(({
  isLoading,
  users,
}) => {
  const { t } = useTranslation();
  const { userStore } = useStores();
  
  const { premiumUsers } = userStore.subscriptionInfo;
  
  return (
    <Grid item container alignItems="center">
      <h3 className="mr-2 font-bold text-xl">
        {t("views.team.title")}
      </h3>
      {
        !isLoading &&
        <Tag
          text={`${users}/${
            premiumUsers.length < 0 ? "∞" : premiumUsers
          }`}
        />
      }
    </Grid>
  )
})

SeatsCounter.propTypes = {
  users: number.isRequired,
  isLoading: bool,
}